<template>
  <asd20-school-directory/>
</template>

<script>
import Asd20SchoolDirectory from '@/components/organisms/Asd20SchoolDirectory'


export default {
  name: 'SchoolsPage',
  components: { Asd20SchoolDirectory },
}
</script>
